import type { CartConfig } from '#types/config/components/cart'

export default {
  brandClasses: {
    eyebrow: 'eyebrow c-grey-10',
    name: 'subtitle-5',
    pricing: 'body-4',
    pricingCurrent: 'subtitle-5',
    promosContainer: 'body-5 c-brand-8',
    variantsContainer: 'body-5 c-black'
  },
  thumbnails: {
    width: { sm: 120 },
    height: { sm: 120 }
  }
} satisfies CartConfig['item']
